'use client';

import { EpRadioYesNo } from '../components/EpRadioYesNo';
import { useFormContext } from 'react-hook-form';

export default function PersonRadio({
  translations,
}: {
  translations: unknown;
}) {
  const { resetField } = useFormContext();

  function handleChange() {
    resetField('unitId.inputValue');
    resetField('unitId.inputLabel');
  }

  return (
    <EpRadioYesNo
      onChange={handleChange}
      legend={'Does this notification refer to a person?'}
      name={'person'}
      translations={translations}
    />
  );
}
